<template>
  <div class="appointment-table">
    <div
      class="appointment-table__head"
      v-bind:class="{ 'is-branch': hasViewBranch }">
      <input-sort
        class="appointment-table__cell"
        :class="{ 'appointment-table__cell__selected': isSortByDate }"
        v-on:input="onSortByDateChanged"
      >
        Дата
      </input-sort>
      <div class="appointment-table__cell">Начало</div>
      <div class="appointment-table__cell">Окончание</div>
      <div class="appointment-table__cell" v-if="hasViewBranch">Филиал</div>
      <div class="appointment-table__cell">Врач</div>
      <div class="appointment-table__cell">Специализации</div>
      <div class="appointment-table__cell">Статус</div>
      <div class="appointment-table__cell">Причина отказа</div>
      <div class="appointment-table__cell center">Примечание</div>
      <div
        class="appointment-table__cell"
        v-if="hasEditVisit" />
    </div>
    <button
      class="appointment-table__row"
      v-bind:class="{ 'is-branch': hasViewBranch }"
      type="button"
      v-bind:key="item.id"
      v-for="item in appointmentList"
      v-on:click="dispatchOpenAppointment(item)">
      <div
        data-label="Дата"
        class="appointment-table__cell">
        {{ item.dateTitle }}
      </div>
      <div
        data-label="Начало"
        class="appointment-table__cell">
        {{ item.startsTime }}
      </div>
      <div
        data-label="Окончание"
        class="appointment-table__cell">
        {{ item.endsTime }}
      </div>
      <div
        v-if="hasViewBranch"
        data-label="Филиал"
        class="appointment-table__cell">
        {{ item.branchName }}
      </div>
      <div
        data-label="Врач"
        class="appointment-table__cell">
        {{ item.employeeName }}
      </div>
      <div
        data-label="Специализации"
        class="appointment-table__cell">
        {{ item.employeeSpeciality }}
      </div>
      <div
        data-label="Статус"
        class="appointment-table__cell"
        v-bind:class="[item.status]">
        <div>
          {{ item.statusTitle }}
          <p>{{ item.cause }}</p>
        </div>
      </div>
      <div
        data-label="Причина отказа"
        class="appointment-table__cell">
        <div>
          {{ item.rejectionReason}}
        </div>
      </div>
      <div
        data-label="Примечание"
        class="appointment-table__cell"
      >
        <button
          v-if="item.note"
          class="appointment-table__icon-view"
          title="Показать примечание"
          type="button"
          v-on:click.prevent.stop="onOpenModalNote(item.note)"
        />
      </div>
      <div
        class="appointment-table__cell align-mob"
        data-label="Редактировать"
        v-if="hasEditVisit">
        <button
          class="appointment-table__icon-edit"
          title="Редактировать"
          type="button"
          v-on:click.stop="dispatchOpenAppointment(item)" />
      </div>
    </button>
  </div>
</template>
<script>
import InputSort from '@/components/InputSort.vue';

/**
 * Сортировать по дате
 *
 * @type {string}
 */
const ON_SORT_BY_DATE = 'on-sort-by-date';

/**
 * @description Событие открытия модального окна примечания.
 * @type {string}
 */
const ON_OPEN_NOTE_MODAL_EVENT = 'on-open-note-modal';

/**
 * @description Таблица визитов пациента.
 * @type {any}
 */
export default {
  components: { InputSort },
  computed: {
    /**
     * @description Может видеть филиал.
     * @returns {boolean}
     */
    hasViewBranch() {
      return this.$store.getters.isSectionAvailable('branch-system');
    },
    hasEditVisit() {
      return this.actions.includes('edit');
    },
  },
  methods: {
    /**
     * @description Отправить событие просмотр записи на прием.
     * @param {any} appointment Запись на прием.
     * @returns {void}
     */
    dispatchOpenAppointment(appointment) {
      this.$emit('open-appointment', appointment);
    },
    /**
     * @description Обработать изменение порядка сортировки по дате.
     * @param {string} order Порядок.
     * @returns {void}
     */
    onSortByDateChanged(order) {
      this.$emit(ON_SORT_BY_DATE, order);
    },
    /**
     * @description Обработать открытие модального окна примечания.
     * @param {string} note Примечание.
     */
    onOpenModalNote(note) {
      this.$emit(ON_OPEN_NOTE_MODAL_EVENT, note);
    },
  },
  props: {
    /**
     * Идёт ли сортировка по дате
     * @type {boolean}
     */
    isSortByDate: {
      required: true,
      type: Boolean,
    },
    /**
     * @description Допустимые действия.
     * @type {string[]}
     */
    actions: { required: true, type: Array },
    /**
     * @description Список записей на прием.
     * @type {any[]}
     */
    appointmentList: { type: Array, default: () => [] },
  },
};
</script>
<style lang="scss">
.invalid {
  background: rgb(247, 64, 64);
}

.appointment-table__cell__selected {
  >label {
    color: var(--action-color);
  }
}
.appointment-table {
  overflow-x: auto;
  counter-reset: counterEmployees;
  &__head,
  &__row {
    width: 100%;
    min-width: 1350px;
    text-align: left;
    display: grid;
    grid-template-columns: 200px 100px 100px 1fr 1fr 210px 210px 110px 43px;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
    &.is-branch {
      grid-template-columns: 200px 100px 100px minmax(110px, 0.5fr) 0.8fr 0.8fr 210px 210px 110px 43px;
    }
  }
  &__row {
    cursor: pointer;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
  }
  &__row {
    border-bottom: 1px solid #eaeff3;
    &:hover {
      background: #eaeff3;
      .appointment-table__cell {
        background: #eaeff3;
      }
    }
  }
  &__cell {
    padding: 12px 8px;
    &.center {
      text-align: center;
    }
    &.size {
      font-size: 16px;
    }
    p {
      margin-bottom: 0;
    }
    &.absent,
    &.unconfirmed,
    &.confirmed,
    &.came,
    &.canceled {
      display: flex;
      word-break: break-all;
      align-items: center;
      height: 100%;
      &:before {
        content: '';
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    &.confirmed {
      background-color: #F3FFE4;
      &:before {
        background-image: url("@/assets/img/checked/checked-green.svg");
        background-repeat: no-repeat;
        background-size: contain;
        height: 15px;
        width: 15px;
      }
    }
    &.unconfirmed {
      background-color: #FFFFFF;
      &:before {
        border-radius: 50%;
        content: "";
        height: 6px;
        width: 6px;
        margin-right: 10px;
        background: #ABB1A3;
      }
    }
    &.came {
      background-color: #E4FFEC;
      &:before {
        background-image: url("@/assets/img/checked/all-checked-green.svg");
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
    &.canceled {
      background-color: #FFECEC;
      align-items: flex-start;
      &:before {
        background-image: url("@/assets/img/exit-red.svg");
        min-width: 20px;
        min-height: 20px;
      }
      span {
        font-style: italic;
        display: flex;
      }
    }
    &.absent {
      background-color: #FFECEC;
      align-items: flex-start;
      &:before {
        background-image: url("@/assets/img/status/absence-red.svg");
        min-width: 20px;
        min-height: 20px;
      }
      span {
        font-style: italic;
        display: flex;
      }
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.number:after {
      counter-increment: counterEmployees;
      content: counter(counterEmployees);
    }
  }
  &__icon {
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-view {
      display: block;
      width: 18px;
      height: 18px;
      margin: 0 auto;
      background: url("@/assets/img/eye-open.svg") no-repeat 50%;
      background-size: contain;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/eye-open-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
}
@media screen and (max-width: 1240px) {
  .appointment-table {
    &__head,
    &__row {
      grid-template-columns: repeat(3, 100px) 1fr 1fr 210px 210px 110px 43px;
      &.is-branch {
        grid-template-columns: 130px repeat(2, 90px) 1fr 1fr 1fr 210px 210px 110px 43px;
      }
    }
  }
}
@media screen and (max-width: 980px) {
  .appointment-table {
    &__head {
      display: none;
    }
    &__row,
    &__row.canceled,
    &__row.is-branch {
      min-width: auto;
      border: 1px solid #eaeff3;
      grid-template-columns: 1fr;
      grid-gap: 5px;
      margin: 0 0 30px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 2px 8px;
      &.absent,
      &.unconfirmed,
      &.confirmed,
      &.came,
      &.canceled,
      &.align-mob {
        justify-content: flex-end;
      }
    }
    &__cell:before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
    }
    &__icon-view {
      margin: 0;
    }
  }
}
</style>
